import React, { useEffect, useState } from 'react';
import { get } from '../services/session.service';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { SessionDetails, ShowingDetails } from '../models/api';
import LoadingSpinner from '../components/LoadingSpinner';
import { list as listShowings } from '../services/showing.service';
import ShowingEditor from '../components/ShowingEditor';
import BackButton from '../components/BackButton';
import Feedback from '../components/Feedback';

const Showings: React.FC = () => {
  const [session, setSession] = useState<SessionDetails | null>();
  const [loading, setLoading] = useState<boolean | null>();
  const [errors, setErrors] = useState([] as string[]);
  const [loadMessage, setLoadMessage] = useState('');

  const [showings, setShowings] = useState<ShowingDetails[]>([]);

  const { reference } = useParams();

  if (!reference) {
    return <NotFound />;
  }

  const getSession = async () => {
    if (!!loading || !reference) {
      return;
    }
    setLoading(true);
    try {
      const [sessionResponse, showingsResponse] = await Promise.all([
        get(reference),
        listShowings(reference)
      ]);
      if (sessionResponse.success && showingsResponse.success) {
        setSession(sessionResponse.data);
        setShowings(showingsResponse.data?.showings || []);
        setErrors([]);
      } else {
        setLoadMessage('');
        setErrors([...sessionResponse.errors, ...showingsResponse.errors]);
      }
    } catch (error) {
      setErrors(['There was a problem loading the event']);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  if (loading === false && !session) {
    setErrors(['There was a problem loading the event']);
  }

  return (
    <>
      {loading && <LoadingSpinner />}
      {loading === false && session && (
        <div className="content-body">
          <BackButton
            target={`/Sessions/${session.reference}`}
            text="Back to event"
          />
          <h1>{session.name}</h1>
          <Feedback message={loadMessage} type="success" />
          <Feedback messages={errors} type="error" />
          <ShowingEditor
            refreshShowings={getSession}
            reference={reference}
            setErrors={setErrors}
            setLoadMessage={setLoadMessage}
            setShowings={setShowings}
            showings={showings}
          />
        </div>
      )}
    </>
  );
};

export default Showings;
